import { Children, type ReactNode } from 'react';

/**
 * Панель — белая поверхность с тенью (кит v2.11). Любой список или
 * таблица живёт в панели; таблица — в `flush`, без внутренних полей.
 * Панель в панель не кладётся (чек-лист кита, п. 16).
 */
export function Panel({
  title,
  count,
  actions,
  flush,
  children,
}: {
  title?: string;
  /** Число рядом с заголовком панели — «Представители 2» */
  count?: number;
  /** Кнопки раздела справа — тихие (`.pha`) */
  actions?: ReactNode;
  flush?: boolean;
  children: ReactNode;
}) {
  return (
    <div className={flush ? 'panel flush' : 'panel'}>
      {title || actions ? (
        <div className="ph">
          {title ? (
            <h2>
              {title}
              {count ? <span className="c">{count}</span> : null}
            </h2>
          ) : (
            <span className="sp" />
          )}
          {actions ? <span className="pha">{actions}</span> : null}
        </div>
      ) : null}
      {children}
    </div>
  );
}

/** Колонка панелей с шагом 12 (`.stack`). */
export function Stack({ children }: { children: ReactNode }) {
  return <div className="stack">{children}</div>;
}

/** Обзор карточки: данные слева, лента справа (`.two.ov`). */
export function Overview({ left, right }: { left: ReactNode; right: ReactNode }) {
  return (
    <div className="two ov">
      <div className="stack">{left}</div>
      <div className="stack">{right}</div>
    </div>
  );
}

/** Пустая связь внутри панели: «Детей и подопечных нет.» */
export function PanelEmpty({ children }: { children: ReactNode }) {
  return <div className="ph-empty">{children}</div>;
}

/**
 * Сигналы над разделом: плашки `.alert`, которые требуют действия.
 * Стоят над вкладками или над панелью раздела, между собой — шаг стопки.
 * Пустые не рисуются.
 */
export function Signals({ children }: { children: ReactNode }) {
  if (!Children.toArray(children).length) return null;
  return (
    <div className="sigs">
      <div className="stack">{children}</div>
    </div>
  );
}

